export const UrlMatchList = [
  "equals",
  "contains",
  "startsWith",
  "endsWith",
  "doesNotEqual",
  "doesNotContain",
  "doesNotStartWith",
  "doesNotEndWith",
  "isNull",
  "isNotNull",
  "regex",
] as const;

export type UrlMatch = (typeof UrlMatchList)[number];

export const PreventUrlSlashList: UrlMatch[] = [
  "equals",
  "doesNotEqual",
  "startsWith",
  "doesNotStartWith",
];

export const DisallowBlankValueList: UrlMatch[] = [
  "contains",
  "doesNotContain",
  "startsWith",
  "endsWith",
  "doesNotStartWith",
  "doesNotEndWith",
];

export type PreventUrlMatch = (typeof PreventUrlSlashList)[number];
